import { render } from "./ExpiryLotForm.vue?vue&type=template&id=db38dd22"
import script from "./ExpiryLotForm.vue?vue&type=script&lang=js"
export * from "./ExpiryLotForm.vue?vue&type=script&lang=js"
script.render = render

export default script